// import * as Preloader from "./functions/preloader.js";
//
// Preloader.show();
const preloader = document.querySelector('.preloader');
preloader.show = () => {
    preloader.classList.add('show');
};
preloader.hide = () => {
    preloader.classList.remove('show');
};
function pikulinTrigger(element,event) {
    if ("createEvent" in document) {
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, false, true);
        element.dispatchEvent(evt);
    }
    else
        element.fireEvent("on"+event);
}

window.addEventListener('load', ()=>{
    // setTimeout(()=>{
    document.body.classList.add('load');
    document.body.classList.add('loaded');
    // let t = 0;
    // document.querySelectorAll('.load-wait').forEach(el=>{
    //     let l = parseFloat(el.getAttribute('data-load-time'));
    //     if(l>t) {
    //         t = l;
    //     }
    // });
    // setTimeout(()=>{
    //     document.body.classList.add('loaded');
    //     pikulinTrigger(window,'loaded');
    // },t*1000);
    // },100);
});

//COOKIE
function setCookie(name, value, options) {
    options = options || {};

    var expires = options.expires;
    if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 60 * 60 * 1000);
        expires = options.expires = d;
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }
    }
    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }
    if(options.SameSite===undefined) {
        if(document.location.protocol==='https:') {
            updatedCookie += '; SameSite=None; Secure';
        } else {
            updatedCookie += '; SameSite=Lax';
        }
    }

    document.cookie = updatedCookie;
}
function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
function deleteCookie(name,options) {
    options.expires = -1;
    setCookie(name, "", options)
}
//EXIT COOKIE

document.querySelectorAll('button[data-for]').forEach(btn=>{
    btn.addEventListener('click',evt=>{
        evt.preventDefault();
        document.getElementById(btn.getAttribute('data-for')).scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
});

document.querySelectorAll('details').forEach(el=>{
    el.addEventListener('click',evt=>{
        if(
            evt.target.tagName!=='SUMMARY' &&
            evt.target.tagName!=='A' &&
            evt.target.tagName!=='BUTTON' &&
            !evt.target.classList.contains('details-no-close') &&
            !evt.target.closest('summary') &&
            !evt.target.closest('a') &&
            !evt.target.closest('button') &&
            !evt.target.closest('.details-no-close')
        ) {
            evt.preventDefault();
            el.querySelector('summary').click();
        }
    });
    if(el.classList.contains('details-one')) {
        el.addEventListener('toggle', function () {
            if (this.open) {
                document.querySelectorAll('details[open]').forEach(s => {
                    if(s!==this) {
                        s.querySelector('summary').click();
                    }
                });
            }
        });
    }
});

//AJAX LOAD PAGE
function initLoadPage() {
    document.querySelectorAll('.btn-load-page:not(.btn-load-page-inited)').forEach(btn=>{
        btn.classList.add('btn-load-page-inited');
        btn.addEventListener('click',(evt)=>{
            evt.preventDefault();
            preloader.show();
            fetch(btn.getAttribute('href'),
                {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: {}
                })
                .then(response => {
                    if (response.status !== 200) {
                        return Promise.reject();
                    }
                    return response.json();
                })
                .then(data => {
                    preloader.hide();
                    changePage(data);
                })
                .catch(e => {
                    console.error(e);
                });
        });
    });
}
initLoadPage();

const main = document.querySelector('main');
function changePage(data) {
    window.history.pushState({}, "", data.uri);
    document.title = data.title;
    const el = document.createElement('div');
    el.classList.add('page');
    el.setAttribute('data-uri',data.uri);
    el.innerHTML = data.html;
    main.appendChild(el);
    const page_current = main.querySelector('.page.current');
    let t= page_current.getBoundingClientRect().height;
    page_current.style.maxHeight = t + 'px';
    t = t/1000 * 0.3;
    page_current.style.transitionDuration = (t<0.3 ? 0.3 : t) + 's';
    page_current.classList.remove('current');
    main.querySelector('.page[data-uri="'+data.uri+'"]').classList.add('current');
    if(typeof data.loader !== 'undefined') {
        if(typeof data.loader.js !== 'undefined') {
            data.loader.js.forEach(loader_data => {
                if(document.querySelector('script[src="'+loader_data.name+'"]')===null) {
                    let l = document.createElement('script');
                    l.type = 'text/javascript';
                    l.async = true;
                    l.src = loader_data.name;
                    document.body.appendChild(l);
                }
            });
        }
        if(typeof data.loader.css !== 'undefined') {
            data.loader.css.forEach(loader_data => {
                if(document.querySelector('link[href="'+loader_data.name+'"]')===null) {
                    let l = document.createElement('link');
                    l.rel = 'stylesheet';
                    l.href = loader_data.name;
                    document.body.appendChild(l);
                }
            });
        }
    }
}
window.addEventListener('popstate', ()=> {
    if(main.querySelector('.page[data-uri="' + window.location.pathname + '"]')!==null) {
        const page_current = main.querySelector('.page.current');
        let t = page_current.getBoundingClientRect().height;
        page_current.style.maxHeight = t + 'px';
        t = t / 1000 * 0.3;
        page_current.style.transitionDuration = (t < 0.3 ? 0.3 : t) + 's';
        page_current.classList.remove('current');
        main.querySelector('.page[data-uri="' + window.location.pathname + '"]').classList.add('current');
    }
});
//EXIT AJAX LOAD PAGE

//TABS
function tabs() {
    document.querySelectorAll('.tabs').forEach(tab=>{
        const bg = tab.querySelector('.item.bg'),
            list = tab.querySelector('ul'),
            left = list.getBoundingClientRect().left + 1;
        function changeBg(item) {
            const rect = item.getBoundingClientRect()
            bg.style.width = rect.width + 'px';
            bg.style.transform = 'translateX(' + (rect.left - left) + 'px)';
        }
        let current_item = tab.querySelector('.item.active');
        changeBg(current_item);
        tab.querySelectorAll('.item:not(.bg)').forEach(item=>{
            item.addEventListener('mouseover', ()=>{
                changeBg(item);
            });
            item.addEventListener('mouseout', ()=>{
                changeBg(current_item);
            });
            item.addEventListener('click', (evt)=>{
                evt.preventDefault();
                if(!item.classList.contains('active')) {
                    current_item.classList.remove('active');
                    item.classList.add('active');
                    current_item = item;
                    changeBg(current_item);
                }
            });
        });
    });
}
window.addEventListener('load', ()=>{
    tabs();
});
//EXIT TABS

function printText(el,text) {
    el.style.minHeight = el.getBoundingClientRect().height + 'px';
    if(typeof el.printText !== 'undefined') {
        if(el.printText.i!==null) {
            clearInterval(el.printText.i);
            el.printText.i = null;
        }
        if(el.printText.i2!==null) {
            clearInterval(el.printText.i2);
            el.printText.i2 = null;
        }
    } else {
        el.printText = {};
    }
    if(el.tagName==='INPUT') {
        const timeout = 300 / (el.value.length + text.length);
        let c = el.value.length;
        el.printText.i = setInterval(() => {
            if (c === 0) {
                clearInterval(el.printText.i);
                el.printText.i = null;
                if(text.length>0) {
                    c = 0;
                    let l = text.length;
                    el.printText.i2 = setInterval(() => {
                        c++;
                        el.value = text.substring(0, c);
                        if (c === l) {
                            clearInterval(el.printText.i2);
                            el.printText.i2 = null;
                            pikulinTrigger(el,'change');
                        }
                    }, timeout);
                }
            } else {
                c--;
                el.value = el.value.substring(0, c);
            }
        }, timeout);
    } else {
        const timeout = 300 / (el.innerText.length + text.length);
        let c = el.innerText.length;
        el.printText.i = setInterval(() => {
            if (c === 0) {
                clearInterval(el.printText.i);
                el.printText.i = null;
                c = 0;
                let l = text.length;
                el.printText.i2 = setInterval(() => {
                    c++;
                    el.innerText = text.substring(0, c);
                    if (c === l) {
                        clearInterval(el.printText.i2);
                        el.printText.i2 = null;
                    }
                }, timeout);
            } else {
                c--;
                el.innerText = el.innerText.substring(0, c);
            }
        }, timeout);
    }
}

const el_notify = document.querySelector('.notify');
let notify_timer = null;
el_notify.removeAttribute('style');
function notify(type,message) {
    el_notify.classList.add('notify-type-'+type);
    el_notify.innerHTML = message;
    el_notify.classList.add('show');
    notify_timer = setTimeout(()=>{
        el_notify.classList.remove('show');
        el_notify.classList.remove('notify-type-'+type);
    },5000);
}

el_notify.addEventListener('click',(evt)=>{
    evt.preventDefault();
    el_notify.classList.remove('show');
    el_notify.className.split(' ').forEach(className => {
        if (className.startsWith('notify-type-')) {
            el_notify.classList.remove(className);
        }
    });
    clearTimeout(notify_timer);
});

const locations_map_el = document.querySelector('.map.locations-map'),
    locations_el = document.querySelector('.blocks-location-info');
if(locations_el!==null) {
    function initLocation() {
        let pathname = window.location.pathname,
            parts_pathname = pathname.split('/'),
            last_pathname = parts_pathname[parts_pathname.length - 2];
        locations_el.querySelectorAll('.block-location-info').forEach(block=>{
            if(last_pathname===block.getAttribute('id')) {
                parts_pathname.splice(parts_pathname.length - 2, 1);
                pathname = parts_pathname.join('/');
            }
        });
        locations_el.querySelectorAll('.block-location-info:not(.init)').forEach(block=>{
            block.classList.add('init');
            const id = block.getAttribute('id');
            block.addEventListener('toggle',function(){
                if(this.open) {
                    window.history.replaceState(null,null,window.location.origin+pathname+id+'/');
                    locations_map_el.map.inactiveMarkers();
                    locations_map_el.map.hideGroups();
                    locations_map_el.map.setViewGroup(id);
                    locations_map_el.map.showGroup(id);
                } else {
                    if(locations_el.querySelectorAll('.block-location-info[open]').length===0) {
                        window.history.replaceState(null,null,window.location.origin+pathname);
                        locations_map_el.map.inactiveMarkers();
                        locations_map_el.map.showGroups();
                        locations_map_el.map.setViewGroup('all');
                    }
                }
            });
        });
        locations_el.querySelectorAll('.block-location-info .btn-info:not(.btn-info-init)').forEach((btn) => {
            btn.classList.add('btn-info-init');
            const data_hidden = btn.closest('.item').querySelectorAll('tr.hidden'),
                btn_text = btn.querySelector('.text'),
                text_hidden = btn_text.getAttribute('data-text-hidden'),
                text_show = btn_text.getAttribute('data-text-showed');
            let current_hidden = btn.classList.contains('current-hidden');
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (current_hidden) {
                    btn.classList.remove('current-hidden');
                    printText(btn_text, text_show);
                    data_hidden.forEach((el) => {
                        el.classList.remove('hidden');
                    });
                    current_hidden = false;
                } else {
                    btn.classList.add('current-hidden');
                    printText(btn_text, text_hidden);
                    data_hidden.forEach((el) => {
                        el.classList.add('hidden');
                    });
                    current_hidden = true;
                }
            });
        });
        locations_el.querySelectorAll('.block-location-info .btn-map:not(.btn-map-init)').forEach((btn) => {
            btn.classList.add('btn-map-init');
            const lat = parseFloat(btn.getAttribute('data-lat')),
                lng = parseFloat(btn.getAttribute('data-lng'));
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if(btn.classList.contains('active')) {
                    btn.classList.remove('active');
                    locations_map_el.map.inactiveMarkers();
                    locations_map_el.map.setViewGroup(btn.closest('.block-location-info').getAttribute('id'));
                } else {
                    locations_el.querySelectorAll('.block-location-info .btn-map.active').forEach(a=>{
                        a.classList.remove('active');
                    });
                    btn.classList.add('active');
                    locations_map_el.map.inactiveMarkers();
                    locations_map_el.map.setView(lat, lng, 19);
                    locations_map_el.map.activeMarker(lat, lng);
                }
            });
        });
    }

    initLocation();
    let observerForLocations = new MutationObserver(initLocation);
    observerForLocations.observe(document.body, {
        childList: true,
        subtree: true,
    });



    if (!locations_el.classList.contains('no-update')) {
        setTimeout(()=>{
            updLocation(locations_el.getAttribute('data-time'));
        }, 20000);
    }
}

function updLocation(last_upd) {
    let data = new FormData();
    if(locations_el.classList.contains('single')) {
        data.append('single', 1);
    }
    data.append('last_upd_location',last_upd);
    let locations = {};
    // locations_el.querySelectorAll('.block-location-info').forEach((el) => {
    //     const items = el.querySelector('.data').querySelectorAll('.item');
    //     let location = {
    //         showed: el.hasAttribute('open'),
    //         tracks_full_info: [],
    //         tracks_active_marker: null,
    //     };
    //     el.querySelector('.data').querySelectorAll('.item').forEach((item) => {
    //         if (!item.querySelector('.btn-info').classList.contains('current-hidden')) {
    //             location.tracks_full_info.push(item.getAttribute('id').substring(5));
    //         }
    //         if(item.querySelector('.btn-map.active')) {
    //             location.tracks_active_marker = item.getAttribute('id').substring(5);
    //         }
    //     });
    //     locations[el.getAttribute('id')] = location;
    // });

    // locations_el.querySelectorAll('.block-location-info').forEach((el) => {
    //     locations[el.getAttribute('id')] = {
    //         tracks: el.querySelector('.data').querySelectorAll('.item').length,
    //         status: el.querySelector('.status').getAttribute('data-status')
    //     };
    // });
    // data.append('locations', JSON.stringify(locations));

    fetch('/location/',
        {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: data
        })
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject();
            }
            return response.json();
        })
        .then(data => {
            if(typeof data.locations!== 'undefined') {
                let t = locations_el.querySelector('.info-empty');
                if(t!==null) {
                    t.remove();
                }
                locations_el.insertAdjacentHTML('afterbegin',data.locations);
            }
            if(typeof data.tracks!== 'undefined') {
                for(let [id,tracks] of Object.entries(data.tracks)) {
                    let t = locations_el.querySelector('.block-location-info#l'+id+' .data .item-empty');
                    if(t!==null) {
                        t.remove();
                    }
                    t = locations_el.querySelector('.block-location-info#l'+id+' .data .btn-map.d-none');
                    if(t!==null) {
                        t.classList.remove('d-none');
                    }
                    locations_el.querySelector('.block-location-info#l'+id+' .data').insertAdjacentHTML('afterbegin',tracks);
                }
            }
            if(typeof data.locations_coords!== 'undefined') {
                locations_map_el.map.addMarkers(data.locations_coords,null,false,false);
                locations_map_el.map.updateView();
            }
            if(typeof data.locations_status!=='undefined') {
                for(let [id,status] of Object.entries(data.locations_status)) {
                    printText(locations_el.querySelector('.block-location-info#l'+id+' .status'),status);
                }
            }
            // locations_el.innerHTML = data.tpl;
            // const old_markers = Object.keys(locations_map_el.map.data.markers).length;
            // locations_map_el.map.addMarkers(data.locations_coords,null,false,false);
            // if(old_l!==Object.keys(locations_map_el.map.data.markers).length) {
            //
            // }
            // if(typeof locations_map_el.map.data.current_view !== 'string') {
            //     locations_map_el.map.setViewGroup('all');
            // }
            // const tmp = document.createElement('div');
            // tmp.innerHTML = data.tpl;
            // tmp.querySelectorAll('.block-location-info').forEach(el=>{
            //     el.classList.remove('animated');
            // });
            // locations_el.innerHTML = tmp.innerHTML;
            // locations_el.querySelectorAll('.block-location-info').forEach(el=>{
            //     el.classList.add('animated');
            // });
            setTimeout(()=>{
                updLocation(data.time);
            }, 20000);
        })
        .catch(e => {
            console.error(e);
            alert('Critical error. Please try again. This page reload');
            window.location.reload(true);
        });
}

const formFunctions = [
    'FieldsValidation',
    'FieldPhone',
    'FieldIsLabel',
    'Form',
];
// START FIELDS VALIDATION
function initFieldsValidation() {
    const form_error_messages = JSON.parse(document.getElementById('form-error-messages').textContent);
    document.addEventListener('invalid', (() => {
        return  (evt) => {
            if(evt.target.classList.contains('is-label')) {
                pikulinTrigger(evt.target,'valid');
            } else {
                const container = evt.target.closest('p');
                if(container!==null) {
                    invalid(container,container.querySelector('.error'),evt);
                }
            }
        };
    })(), true);
    document.addEventListener('valid', (() => {
        return  (evt) => {
            const container = evt.target.closest('p');
            if(container!==null) {
                valid(container,container.querySelector('.error'),evt);
            }
        };
    })(), true);
    document.querySelectorAll('input:not(.active-validation)').forEach(field=>{
        field.classList.add('active-validation');
        const container = field.closest('p');
        field.addEventListener('change',()=>{
            if(field.classList.contains('is-label')) {
                container.classList.remove('invalid');
            } else {
                field_validate(field);
                field.checkValidity();
            }
        });
        field.addEventListener('focusout',()=>{
            setTimeout(()=>{
                if(field.classList.contains('is-label')) {
                    container.classList.remove('invalid');
                } else {
                    field_validate(field);
                    field.checkValidity();
                }
            },100);
        });
        field.addEventListener('focusin',()=>{
            container.classList.remove('invalid');
        });
    });
    function field_validate(field) {
        if(typeof field.customErrors !== 'undefined') {
            field.setCustomValidity(field.customErrors.hasOwnProperty(field.value) ? field.customErrors[field.value] : '');
            field.reportValidity();
        }
    }
    function invalid(container,container_error = undefined,evt = undefined) {
        container.classList.add('invalid');
        container.classList.remove('valid');
        if(typeof evt !== 'undefined') {
            let message = evt.target.validationMessage,
                message_error = '';
            if (evt.target.validity.badInput) {
                message_error = 'badInput';
            } else if (evt.target.validity.patternMismatch) {
                message_error = 'patternMismatch';
            } else if (evt.target.validity.rangeOverflow) {
                message_error = 'rangeOverflow';
            } else if (evt.target.validity.rangeUnderflow) {
                message_error = 'rangeUnderflow';
            } else if (evt.target.validity.stepMismatch) {
                message_error = 'stepMismatch';
            } else if (evt.target.validity.tooLong) {
                message_error = 'tooLong';
            } else if (evt.target.validity.tooShort) {
                message_error = 'tooShort';
            } else if (evt.target.validity.typeMismatch) {
                message_error = 'typeMismatch';
            } else if (evt.target.validity.valueMissing) {
                message_error = 'valueMissing';
            }
            if (message_error.length > 0) {
                if (
                    typeof form_error_messages[evt.target.getAttribute('type')] !== 'undefined' &&
                    typeof form_error_messages[evt.target.getAttribute('type')][message_error] !== 'undefined'
                ) {
                    message = form_error_messages[evt.target.getAttribute('type')][message_error];
                } else if (typeof form_error_messages.all[message_error] !== 'undefined') {
                    message = form_error_messages.all[message_error];
                }
            }
            container_error.innerText = message;
            evt.preventDefault();
        }
    }
    function valid(container,container_error = undefined,evt = undefined) {
        container.classList.add('valid');
        container.classList.remove('invalid');
        if(typeof evt !== 'undefined') {
            container_error.innerText = '';
            evt.preventDefault();
        }
    }
    document.querySelectorAll('form').forEach(form=>{
        form.addEventListener('form-invalid',()=>{
            invalid(form);
            form.addEventListener('change',form_change);
        });
        form.addEventListener('form-valid',()=>{
            valid(form);
        });
        function form_change() {
            valid(form);
            form.removeEventListener('change',form_change);
        }
    });
}
// EXIT FIELDS VALIDATION
// START FIELD PHONE
function initFieldPhone() {
    document.querySelectorAll('.field-phone:not(.active-field-phone)').forEach(container=>{
        container.classList.add('active-field-phone');
        const field = container.querySelector('.input-phone'),
            field_country = container.querySelector('.input-phone-country'),
            field_container = container.querySelector('.input');
        container.querySelector('label').addEventListener('click',(evt)=>{
            if(
                evt.target.tagName==='button' ||
                evt.target.closest('button')!==null
            ) {
                return false;
            }
            evt.preventDefault();
            if(
                (
                    evt.target.closest('.input')===null ||
                    (
                        !evt.target.closest('.input').parentElement.classList.contains('input') &&
                        evt.target.closest('.input').parentElement.closest('.input')===null
                    )
                ) &&
                evt.target.tagName!=='button' &&
                evt.target.closest('button') === null
            ) {
                field.focus();
                field.setSelectionRange(field.value.length, field.value.length, "forward");
            }
        });
        field_country.addEventListener('change',()=>{
            const selected = document.querySelector('.'+field_country.closest('.pikulin-select').getAttribute('data-options-class') + ' button.selected'),
                new_code = selected.getAttribute('data-code'),
                old_code = field_container.getAttribute('data-code').replaceAll(' ','').replaceAll('-',''),
                new_placeholder = selected.getAttribute('data-placeholder'),
                new_minlength = selected.getAttribute('data-minlength'),
                new_maxlength = selected.getAttribute('data-maxlength');
            field_container.setAttribute('data-code',new_code);
            field_container.setAttribute('data-placeholder',new_placeholder);
            if(field.value.replaceAll(' ','').replaceAll('-','') === '+'+old_code) {
                field.value = '+'+new_code;
            }
            else if(field.value.replaceAll(' ','').replaceAll('-','').substring(0,old_code.length+1) === '+'+old_code) {
                field.value = '+'+new_code+field.value.substring(old_code.length+1);
            } else if(field.value.replaceAll(' ','').replaceAll('-','') === '+'+new_code) {
                field.value = '+' + field.value;
            }
            else {
                field.value = '+' + new_code + field.value;
            }
            field.setAttribute('minlength',new_minlength);
            field.setAttribute('maxlength',new_maxlength);
            field.setAttribute('pattern','.{'+new_minlength+','+new_maxlength+'}');
            phoneFormat(field_container,field,'');
        });
        field.addEventListener('blur',()=>{
            phoneFormat(field_container,field,this,false);
            phoneCode(field_container,field,field_country);
        });
        field.addEventListener('paste',()=>{
            setTimeout(()=>{
                phoneFormat(field_container,field,'');
                phoneCode(field_container,field,field_country);
            }, 50);
        });
        field.addEventListener('keydown', (evt) => {
            if (evt.keyCode === 8 || evt.keyCode === 46)
            {
                evt.preventDefault();
                phoneFormat(field_container,field,'', this.selectionStart === this.selectionEnd);
                phoneCode(field_container,field,field_country);
            }
        });
        field.addEventListener('input', (evt) => {
            let value = field.value,
                lastChar = value.charAt(value.length - 1);
            field.value = value.slice(0, -1);
            
            if (/\D/.test(lastChar)) {
                return;
            }

            phoneFormat(field_container, field, lastChar);
            phoneCode(field_container, field, field_country);
        });
        field.addEventListener('change',()=>{
            phoneFormat(field_container,field,'');
            phoneCode(field_container,field,field_country);
        });
    });
    function phoneFormat(field_container,field,char,backspace) {
        let start = 0,
            end = 0,
            pos = 0,
            separator = " ",
            d = 0,
            dd = 0,
            gi = 0,
            v = '',
            groups = [],
            placeholder = field_container.getAttribute('data-placeholder'),
            placeholder_length = placeholder.length,
            separators = [],
            max_length = field.getAttribute('maxlength');

        if(placeholder_length < max_length) {
            for(let i = placeholder_length; i<max_length;i++) {
                placeholder += '0';
            }
        }

        let groups_example = placeholder.split(' ');

        if(placeholder.includes('-')) {
            let new_groups_example = [];
            for(let i = 0; i<groups_example.length;i++) {
                if(groups_example[i].includes('-')) {
                    let groups_example_sub = groups_example[i].split('-');
                    for(let j = 0; j<groups_example_sub.length;j++) {
                        new_groups_example.push(groups_example_sub[j]);
                        separators.push('-');
                    }
                } else {
                    new_groups_example.push(groups_example[i]);
                    separators.push(' ');
                }
            }
            groups_example = new_groups_example;
        } else {
            for(let i = 0; i<groups_example.length;i++) {
                separators.push(' ');
            }
        }

        for(let i = 0; i<groups_example.length;i++) {
            groups.push(groups_example[i].replace(/\D/g, '').length);
        }

        if (char !== false)
        {
            start = field.selectionStart;
            end = field.selectionEnd;

            if (backspace && start > 0) // handle backspace onkeydown
            {
                start -= field.value[start] === separator ? 2 : 1;
            }
            // To be able to replace the selection if there is one
            field.value = field.value.substring(0, start) + char + field.value.substring(end);

            pos = start + char.length; // caret position
        }

        for (let i = 0; i < field.value.length; i++)
        {
            if (/\D/.test(field.value[i]))
            {
                if (start > i)
                { pos--; }
            }
            else
            {
                if (d === groups[gi])
                {
                    v += separators[gi];
                    d = 0;
                    gi++;

                    if (start >= i)
                    { pos++; }
                }
                v += field.value[i];
                d++;
                dd++;
            }
            if (d === groups[gi] && groups.length === gi + 1) // max length
            {
                break;
            }
        }
        field.value = '+'+v;
        pos++;
        if(placeholder_length < max_length) {
            placeholder = placeholder.substring(0,placeholder_length);
        }
        field_container.setAttribute('data-placeholder',field.value+placeholder.substring(field.value.length));

        if (char !== false)
        { field.setSelectionRange(pos, pos); }
    }
    function phoneCode(field_container,field,field_country) {
        const current_code = field_container.getAttribute('data-code');
        let finded = false,
            priority = 0;
        const v = field.value.replaceAll(' ','').replaceAll('-','').substring(1);
        document.querySelectorAll('.'+field_country.closest('.pikulin-select').getAttribute('data-options-class') + ' button').forEach(btn=>{
            const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0;
            if(
                !finded ||
                p>priority
            ) {
                const code = btn.getAttribute('data-code');
                if (current_code!==code && code === v.substring(0, code.length)) {
                    finded = true;
                    priority = p;
                    pikulinTrigger(btn, 'click');
                }
            }
        });
    }
}
//EXIT FIELD PHONE
function initFieldIsLabel() {
    document.querySelectorAll('.is-label').forEach(field=>{
        field.addEventListener('click',(evt)=>{
            if(field.classList.contains('is-label')) {
                evt.preventDefault();
                field.closest('label').click();
            }
        });
    });
}
//start submit
function initForm() {
    document.querySelectorAll('form:not(.active-form):not(.custom-submit-form)').forEach(form=>{
        form.classList.add('active-form');
        form.addEventListener('submit',(evt)=>{
            evt.preventDefault();
            submit(form,null);
        });
        form.querySelectorAll('input').forEach(field=>{
            field.addEventListener('keydown',(evt)=>{
                if(evt.keyCode === 13) {
                    submit(form,null);
                }
            });
        });
    });

    document.querySelectorAll('.btn-ajax-form:not(.btn-ajax-form-inited)').forEach(btn => {
        btn.classList.add('btn-ajax-form-inited');
        btn.addEventListener('click',(evt)=>{
            evt.preventDefault();
            if (btn.classList.contains('with-confirmation-modal')) {
                if (btn.hasAttribute('data-confirmation-text')) {
                    document.querySelector('#modal-form-confirmation .confirmation-text').innerHTML = btn.getAttribute('data-confirmation-text');
                }
                let modal = document.getElementById('modal-form-confirmation');
                pikulinModalShow(modal);
                modal.addEventListener('closed', fieldBack)
                let modal_btn_set = modal.querySelector('.btn-set');
                modal_btn_set.addEventListener('click', fieldConfirm);

                function fieldConfirm(e) {
                    e.preventDefault();
                    modal_btn_set.removeEventListener('click',fieldConfirm);
                    let form_data = new FormData();
                    if(btn.hasAttribute('data-data')) {
                        Object.entries(JSON.parse(btn.getAttribute('data-data'))).forEach(([key,value]) => {
                            form_data.append(key,value);
                        });
                    }
                    submit(btn, form_data,null,null);
                    pikulinModalClose();
                }

                function fieldBack() {
                    modal_btn_set.removeEventListener('click',fieldConfirm);
                    pikulinModalClose();
                }
            } else {
                let form_data = new FormData();
                if(btn.hasAttribute('data-data')) {
                    Object.entries(JSON.parse(btn.getAttribute('data-data'))).forEach(([key,value]) => {
                        form_data.append(key,value);
                    });
                }
                submit(btn, form_data,null,null);
            }

        });
    });
}
function submit(form,formdata) {
    if(formdata===null) {
        formdata = new FormData(form);
    }
    window.onbeforeunload = ()=>{
        return 'Are you sure you want to leave?';
    };
    preloader.show();
    const form_uri = form.hasAttribute('action') ? form.getAttribute('action') : (form.hasAttribute('data-action')? form.getAttribute('data-action') : window.location.pathname);
    fetch(form_uri,
        {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formdata
        })
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject();
            }
            return response.json();
        })
        .then(data => {
            window.onbeforeunload = ()=>{};
            preloader.hide();
            if('undefined' !== typeof data.reload) {
                window.location.reload(true);
                return;
            }
            if('undefined' !== typeof data.redirect) {
                if('undefined'===typeof data.redirect_data) {
                    let btn = document.createElement('a');
                    btn.setAttribute('href', data.redirect);
                    btn.click();
                } else {
                    let tmp_form = document.createElement('form');
                    tmp_form.classList.add('d-none');
                    tmp_form.action = data.redirect;
                    tmp_form.method = 'get';
                    Object.entries(data.redirect_data).forEach(([input_name,input_value])=>{
                        let tmp_input = document.createElement('input');
                        tmp_input.type = 'text';
                        tmp_input.name = input_name;
                        tmp_input.value = input_value;
                        tmp_form.appendChild(tmp_input);
                    });
                    document.body.appendChild(tmp_form);
                    tmp_form.submit();
                }
                return;
            }
            else if('undefined' !== typeof data.errors) {
                if(form.tagName!=='FORM' && !form.classList.contains('.custom-form')) {
                    let t = form.closest('form');
                    if(t===null) {
                        t = form.closest('.custom-form');
                        if(t!==null) {
                            form = t;
                        }
                    } else {
                        form = t;
                    }
                }
                Object.entries(data.errors).forEach(([key,value]) => {
                    // if(typeof key === 'string') {
                    if(key==='form') {
                        const f = form.querySelector('.form-error');
                        f.innerText = value;
                        pikulinTrigger(form,'form-invalid');
                    } else {
                        const f = form.querySelector('[name="' + key + '"]');
                        if (typeof f.customErrors === 'undefined') {
                            f.customErrors = {};
                        }
                        f.customErrors[f.value] = value;
                        f.setCustomValidity(value);
                        f.reportValidity();
                        // pikulinTrigger(f,'invalid');
                    }
                    // }
                });
            } else {
                if('undefined' !== typeof data.page) {
                    changePage(data.page);
                }
            }
            if ('undefined' !== typeof data.change) {
                Object.entries(data.change).forEach(([toggle, item]) => {
                    if (!isNaN(parseInt(toggle))) {
                        toggle = item.toggle;
                    }
                    switch (item.action ?? null) {
                        case 'content':
                        case 'html':
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                tmp_el.innerHTML = item.data;
                            });
                            break;
                        case 'text':
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                printText(tmp_el,item.data);
                            });
                            break;
                        case 'append':
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                tmp_el.innerHTML += item.data;
                            });
                            break;
                        case 'remove':
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                tmp_el.remove();
                            });
                            break;
                        case 'classAdd':
                            if (item.data.indexOf(';')) {
                                item.data.split(';').forEach(item_data => {
                                    document.querySelectorAll(toggle).forEach(tmp_el => {
                                        tmp_el.classList.add(item_data);
                                    });
                                });
                            } else {
                                document.querySelectorAll(toggle).forEach(tmp_el => {
                                    tmp_el.classList.add(item.data);
                                });
                            }
                            break;
                        case 'setAttribute':
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                tmp_el.setAttribute(item.data.name, item.data.value);
                            });
                            break;
                        case 'removeAttribute':
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                tmp_el.removeAttribute(item.data.name);
                            });
                            break;
                        case 'classRemove':
                            if (item.data.indexOf(';')) {
                                item.data.split(';').forEach(item_data => {
                                    document.querySelectorAll(toggle).forEach(tmp_el => {
                                        tmp_el.classList.remove(item_data);
                                    });
                                });
                            } else {
                                document.querySelectorAll(toggle).forEach(tmp_el => {
                                    tmp_el.classList.remove(item.data);
                                });
                            }
                            break;
                        case 'checked':
                            document.querySelector(toggle).checked = item.data;
                            break;
                        case 'value':
                            const t = document.querySelector(toggle);
                            t.value = item.data;
                            if(t.tagName==='TEXTAREA') {
                                t.innerText = item.data;
                            }
                            break;
                        default:
                            document.querySelectorAll(toggle).forEach(tmp_el => {
                                tmp_el.value = item.data;
                                if ("createEvent" in document) {
                                    let evt = document.createEvent("HTMLEvents");
                                    evt.initEvent("change", false, true);
                                    tmp_el.dispatchEvent(evt);
                                } else {
                                    tmp_el.fireEvent("onchange");
                                }
                            });
                            break;
                    }
                });
            }
            if('undefined'!== typeof data.notify) {
                notify(data.notify.type,data.notify.message);
            }
        })
        .catch(e => {
            window.onbeforeunload = ()=>{};
            console.error(e);
            alert('Critical error. Please try again. This page reload');
            window.location.reload(true);
        });
}
//exit submit

function initFormFunctions() {
    formFunctions.forEach(fn => {
        window['init'+fn]();
    });
}
initFormFunctions();
let observerForForms = new MutationObserver(initFormFunctions);
observerForForms.observe(document.body, {
    childList: true,
    subtree: true,
});

function initPikulinSelect() {
    document.querySelectorAll('.pikulin-select:not(.pikulin-select-inited)').forEach(container=>{
        container.classList.add('pikulin-select-inited');
        const class_name = 't'+Date.now(),
            field = document.querySelector(container.querySelector('.pikulin-select-options').getAttribute('data-toggle'));
        container.setAttribute('data-options-class',class_name);
        if(!field.hasAttribute('readonly') && !field.hasAttribute('disabled')) {
            let t = container.querySelector('.pikulin-select-options').cloneNode(true);
            t.classList.add(class_name);
            if(!container.classList.contains('select-options-full-width')) {
                t.style.width = t.hasAttribute('data-width') ?
                    'calc(' + container.getBoundingClientRect().width + 'px ' + t.getAttribute('data-width') + ')' :
                    container.getBoundingClientRect().width + 'px';
            }
            document.body.appendChild(t);
            t = document.querySelector('.pikulin-select-options.'+class_name);
            t.outerHTML = t.outerHTML.substring(0,t.outerHTML.length-7).replace('<span ','<div ')+'</div>';

            const options = document.querySelector('.pikulin-select-options.'+class_name),
                options_duration = parseFloat(getComputedStyle(options).transitionDuration) * 1000,
                options_btns = options.querySelectorAll('button'),
                options_with_value = options_btns[0].hasAttribute('data-value'),
                label = container.closest('label'),
                display_value = container.querySelector('.display-value'),
                display_value_img = container.classList.contains('with-img') ? display_value.querySelector('img') : null,
                display_value_uri = display_value_img===null ? '' : display_value_img.getAttribute('data-uri');

            let options_max_lines = 0,
                showed = false,
                options_max_height = options.children[0].getBoundingClientRect().height * options.children.length,
                find_str = '';
            if(options.hasAttribute('data-max-lines')) {
                let t = parseInt(options.getAttribute('data-max-lines'));
                if(!isNaN(t) && t>0) {
                    options_max_lines = t;
                    options_max_height = options.children[0].getBoundingClientRect().height * options_max_lines;
                }
            }

            if(
                label===null ||
                (
                    label.hasAttribute('for') && (!field.hasAttribute('id') || label.getAttribute('for')!==field.getAttribute('id'))
                )
            ) {
                container.addEventListener('click',display);
            } else {
                label.addEventListener('click',display);
            }

            function display(evt) {
                evt.preventDefault();
                if (showed) {
                    hideList();
                } else {
                    showList();
                }
            }

            function showList() {
                showed = true;
                find_str = '';

                const rect = container.getBoundingClientRect(),
                    h_top = rect.top,
                    h_bottom = window.innerHeight - rect.bottom;
                options.style.left = rect.left + 'px';
                if(h_bottom>=h_top || h_bottom>=options_max_height) {
                    options.style.top = (rect.top + rect.height) + 'px';
                    options.style.bottom = 'unset';
                    options.style.maxHeight = h_bottom>=options_max_height ? options_max_height + 'px' : h_bottom + 'px';
                }
                else if(h_top>=options_max_height) {
                    options.classList.add('top');
                    options.style.bottom = window.innerHeight - h_top + 'px';
                    options.style.top = 'unset';
                    options.style.maxHeight = options_max_height + 'px';
                }
                else {
                    options.classList.add('top');
                    options.style.top = 'unset';
                    options.style.bottom = window.innerHeight - h_top + 'px';
                    options.style.maxHeight = h_top + 'px';
                }
                let tmp = options.querySelector('button.selected');
                if (tmp !== null) {
                    options.scrollTo(0, tmp.offsetTop);
                }

                setTimeout(() => {
                    options.classList.add('show');
                    container.classList.add('showed');
                    window.addEventListener('scroll',hideList);
                    document.body.addEventListener('click', onBodyClick);
                    document.body.addEventListener('keyup', onKeyUp);
                }, 1);
            }

            function hideList() {
                showed = false;
                window.removeEventListener('scroll',hideList);
                document.body.removeEventListener('click',onBodyClick);
                document.body.removeEventListener('keyup',onKeyUp);
                options.classList.remove('show');
                container.classList.remove('showed');
                if(options.classList.contains('top')) {
                    setTimeout(() => {
                        if (!showed) {
                            options.classList.remove('top');
                        }
                    }, options_duration + 1);
                }
            }

            function onBodyClick(evt) {
                if (
                    !evt.target.classList.contains(class_name) &&
                    !evt.target.closest('.' + class_name) &&
                    !evt.target.classList.contains('pikulin-select') &&
                    !evt.target.classList.contains('showed') &&
                    !evt.target.closest('.pikulin-select.showed')
                ) {
                    hideList();
                }
            }

            function onKeyUp(evt) {
                let find = false;
                if (evt.keyCode === 8 || evt.keyCode === 46) {
                    if(find_str.length>0) {
                        find_str = find_str.substring(0,find_str.length - 1);
                        find = true;
                    }
                } else {
                    const code = evt.charCode || evt.keyCode || evt.which,
                        char = String.fromCharCode(code).toLowerCase();

                    if (char.toUpperCase() != char || char.toUpperCase() == char || /\D/.test(char)===false) {
                        find = true;
                        find_str += char;
                    }
                }
                if(find) {
                    let finded = false,
                        priority = 0;
                    if (options_btns[0].hasAttribute('data-text')) {
                        options_btns.forEach(btn => {
                            const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0
                            if (
                                btn.getAttribute('data-text').toLowerCase().startsWith(find_str) &&
                                (
                                    !finded ||
                                    p>priority
                                )
                            ) {
                                finded = true;
                                options.scrollTo(0, btn.offsetTop);
                                priority = p;
                            }
                        });
                    }
                    else {
                        options_btns.forEach(btn => {
                            const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0
                            if (
                                btn.innerText.toLowerCase().startsWith(find_str) &&
                                (
                                    !finded ||
                                    p>priority
                                )
                            ) {
                                finded = true;
                                options.scrollTo(0, btn.offsetTop);
                                priority = p;
                            }
                        });
                    }
                    if (!finded && options_with_value) {
                        options_btns.forEach(btn => {
                            const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0
                            if (
                                btn.getAttribute('data-value').toLowerCase().startsWith(find_str) &&
                                (
                                    !finded ||
                                    p>priority
                                )
                            ) {
                                finded = true;
                                options.scrollTo(0, btn.offsetTop);
                                priority = p;
                            }
                        });
                    }
                    if (!finded) {
                        if (options_btns[0].hasAttribute('data-text')) {
                            options_btns.forEach(btn => {
                                const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0
                                if (
                                    btn.getAttribute('data-text').toLowerCase().includes(find_str) &&
                                    (
                                        !finded ||
                                        p>priority
                                    )
                                ) {
                                    finded = true;
                                    options.scrollTo(0, btn.offsetTop);
                                    priority = p;
                                }
                            });
                        }
                        else {
                            options_btns.forEach(btn => {
                                const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0
                                if (
                                    btn.innerText.toLowerCase().includes(find_str) &&
                                    (
                                        !finded ||
                                        p>priority
                                    )
                                ) {
                                    finded = true;
                                    options.scrollTo(0, btn.offsetTop);
                                    priority = p;
                                }
                            });
                        }
                    }
                    if (!finded && options_with_value) {
                        options_btns.forEach(btn => {
                            const p = btn.hasAttribute('data-priority') ? parseInt(btn.getAttribute('data-priority')) : 0
                            if (
                                btn.getAttribute('data-value').toLowerCase().includes(find_str) &&
                                (
                                    !finded ||
                                    p>priority
                                )
                            ) {
                                finded = true;
                                options.scrollTo(0, btn.offsetTop);
                                priority = p;
                            }
                        });
                    }
                }
            }

            let btn_clicked = false;
            options_btns.forEach(btn=>{
                btn.addEventListener('click',(evt)=>{
                    evt.preventDefault();
                    if(showed) {
                        hideList();
                    }
                    if(!btn.classList.contains('selected')) {
                        let s = options.querySelector('button.selected');
                        if(s!==null) {
                            s.classList.remove('selected');
                        }
                        btn.classList.add('selected');
                        if(options_with_value) {
                            field.value = btn.getAttribute('data-value');
                        } else {
                            field.value = btn.innerText;
                        }
                        if(btn.hasAttribute('data-display-value')) {
                            field.setAttribute('data-display-value',btn.getAttribute('data-display-value'));
                        } else {
                            field.removeAttribute('data-display-value');
                        }
                        btn_clicked = true;
                        pikulinTrigger(field,'change');
                    }
                });
            });
            field.addEventListener('change',()=>{
                if(display_value_img===null) {
                    if(field.hasAttribute('data-display-value')) {
                        display_value.innerHTML = field.getAttribute('data-display-value');
                    } else {
                        display_value.innerText = field.value;
                    }
                } else {
                    display_value_img.setAttribute('src',display_value_uri.replace('%v',field.value));
                }

                if(btn_clicked) {
                    btn_clicked = false;
                } else {
                    let finded = false;
                    if(options_with_value) {
                        options_btns.forEach(btn => {
                            if (btn.getAttribute('data-value') === field.value) {
                                finded = true;
                                if (!btn.classList.contains('selected')) {
                                    let s = options.querySelector('button.selected');
                                    if (s !== null) {
                                        s.classList.remove('selected');
                                    }
                                    btn.classList.add('selected');
                                }
                            }
                        });
                    }
                    if(!finded) {
                        options_btns.forEach(btn => {
                            if (btn.innerText === field.value) {
                                if (!btn.classList.contains('selected')) {
                                    let s = options.querySelector('button.selected');
                                    if (s !== null) {
                                        s.classList.remove('selected');
                                    }
                                    btn.classList.add('selected');
                                }
                            }
                        });
                    }
                    // display_value.innerText = field.value;
                }
            });
        }
        container.querySelector('.pikulin-select-options').remove();
    });
}
initPikulinSelect();

function isTouchDevice() {
    return ('ontouchstart' in window);
}

const btn_menu = document.querySelector('.btn-menu'),
    btn_menu_nav = document.querySelectorAll('.site-header nav.main-menu, .site-header nav.actions-menu'),
    header = document.querySelector('.site-header');
if(btn_menu!==null) {
    btn_menu.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (btn_menu.classList.contains('show')) {
            document.body.classList.remove('overflow-hidden');
            btn_menu.classList.remove('show');
            btn_menu_nav.forEach((nav, index) => {
                nav.classList.remove('show');
            });
        } else {
            document.body.classList.add('overflow-hidden');
            btn_menu.classList.add('show');
            btn_menu_nav.forEach((nav, index) => {
                nav.classList.add('show');
                nav.setAttribute('style', '--header-height:' + header.getBoundingClientRect().height + 'px');
            });
        }
    });
}

function btnWithTimer() {
    document.querySelectorAll('.btn-with-timer:not(.init-timer)').forEach(btn=>{
        btn.classList.add('init-timer');
        if(btn.classList.contains('active-timer')) {
            startTimer();
        } else {
            let observerForBtnTimer = new MutationObserver(startTimer);
            observerForBtnTimer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        }

        function startTimer() {
            if(btn.classList.contains('active-timer')) {
                btn.classList.remove('active-timer');
                btn.setAttribute('disabled','disabled');
                const t = btn.querySelector('.btn-time-display'),
                    d = t.innerText;
                let numbers = d.match(/\d+/g);
                numbers = numbers.map(Number);
                if(t.classList.contains('d-none')) {
                    t.classList.remove('d-none');
                }
                let time = numbers[0],
                    i = setInterval(()=>{
                        let old_time = time;
                        time--;
                        if(time===0) {
                            clearInterval(i);
                            t.classList.add('d-none');
                            t.innerText = d;
                            btn.removeAttribute('disabled');
                        } else {
                            t.innerText = t.innerText.replace(old_time,time);
                        }
                    },1000);
            }
        }
    });
}
btnWithTimer();
let observerForBtnWithTimer = new MutationObserver(btnWithTimer);
observerForBtnWithTimer.observe(document.body, {
    childList: true,
    subtree: true,
});